(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6522],{

/***/ 82044:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-tutorials",
      function () {
        return __webpack_require__(43042);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js + 2 modules
var Breadcrumbs = __webpack_require__(7885);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./reusable/icons/BreadCrumbsIcon.tsx

var SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "4",
        height: "8",
        viewBox: "0 0 4 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.5 7L0.5 4L3.5 1",
            stroke: "#D5D5D5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var BreadCrumbsIcon = (SvgComponent);

;// CONCATENATED MODULE: ./common/BreadCrumbsData.tsx
var BreadCrumbsData = {
    PrivacyPolicy: {
        links: [
            {
                title: "מדיניות הפרטיות",
                link: "/privacy-policy"
            }, 
        ]
    },
    TermsOfUse: {
        links: [
            {
                title: "תנאי שימוש",
                link: "/terms-of-use"
            }, 
        ]
    },
    Accessibility: {
        links: [
            {
                title: "הצהרת נגישות",
                link: "/accessibility"
            }, 
        ]
    },
    SiteMap: {
        links: [
            {
                title: "מפת אתר",
                link: "/sitemap"
            }
        ]
    },
    Recall: {
        links: [
            {
                title: "קריאות חוזרות",
                link: "/recall"
            }, 
        ]
    },
    Warranty: {
        links: [
            {
                title: "כתב אחריות",
                link: "/warranty"
            }, 
        ]
    },
    ServiceInstructions: {
        links: [
            {
                title: "הוראות שירות",
                link: "/service-instructions"
            }, 
        ]
    },
    WarrantyExtension: {
        links: [
            {
                title: "בדיקת תכולת הארכת אחריות",
                link: "/warranty-extension"
            }
        ]
    },
    SparePriceList: {
        links: [
            {
                title: "מחירון מוצרי תעבורה",
                link: "/spare-price-list"
            }, 
        ]
    },
    ColorCode: {
        links: [
            {
                title: "קוד צבע",
                link: "/color-code"
            }, 
        ]
    },
    Hamesayat: {
        links: [
            {
                title: "המסייעת",
                link: "/hamesayat"
            }, 
        ]
    },
    VideoTutorials: {
        links: [
            {
                title: "סרטוני הדרכה ותפעול",
                link: "/video-tutorials"
            }, 
        ]
    },
    ServicesCenters: {
        links: [
            {
                title: "מרכזי שירות",
                link: "/services-centers"
            }, 
        ]
    },
    ShowRooms: {
        links: [
            {
                title: "אולמות תצוגה",
                link: "/show-rooms"
            }, 
        ]
    },
    CarList: {
        links: [
            {
                title: "מחירון מכוניות",
                link: "/car-list"
            }, 
        ]
    },
    Insurance: {
        links: [
            {
                title: "ביטוח",
                link: "/insurance"
            }, 
        ]
    },
    CarFleets: {
        links: [
            {
                title: "ציי רכב",
                link: "/car-fleets"
            }, 
        ]
    },
    ContactUs: {
        links: [
            {
                title: "צרו קשר",
                link: "/contact-us"
            }, 
        ]
    },
    ServicePlans: {
        links: [
            {
                title: "תוכנית טיפול",
                link: "/service-plans"
            }, 
        ]
    }
};


// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
;// CONCATENATED MODULE: ./common/BreadCrumbs.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n\n  ",
        " {\n  }\n  ",
        " {\n    position: absolute;\n\n    ",
        ";\n    ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  max-width: 1400px;\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n    display: flex;\n    justify-content: flex-start;\n    padding-right: 20px;\n  }\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n  }\n  svg {\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n  font-weight: 300;\n  letter-spacing: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var SINGLE_SERVICE = "singleService";
var CONFIGURATOR = "configurator";
var StyledInnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledInnerWrapper",
    componentId: "sc-e82e91a2-0"
})(_templateObject(), function(p) {
    return p.$page === SINGLE_SERVICE && "top: -20px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 25px";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "right: 50px;";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "top: -10px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 0px";
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledWrapper",
    componentId: "sc-e82e91a2-1"
})(_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) !== CONFIGURATOR && "width: 100%;";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$page === CONFIGURATOR && "margin-top: -50px";
}, function(p) {
    return p.$page === CONFIGURATOR && (p === null || p === void 0 ? void 0 : p.$pathname) !== constants/* STEPS_EN.summary */.Ws.summary && "margin-right: 50px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "padding-right: 15px;";
}, function(p) {
    return p.$pathname === constants/* STEPS_EN.color */.Ws.color && "padding-right: 16px";
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "BreadCrumbs__StyledLink",
    componentId: "sc-e82e91a2-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.disable;
});
var BreadCrumbsWrapper = function(param) {
    var name = param.name, modelName = param.modelName, id = param.id, page = param.page, pathname = param.pathname;
    var router = (0,client_router.useRouter)();
    var carLinkUrl = function() {
        var carLink = "/model/[modelId]/[modelSlug]".replace("[modelId]", id.toString()).replace("[modelSlug]", (0,slugify/* default */.Z)(modelName));
        return carLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        $page: page,
        $pathname: pathname,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerWrapper, {
            $page: page,
            children: [
                BreadCrumbsData[name] && !modelName && !id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        BreadCrumbsData[name].links.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                color: "inherit",
                                href: item.link,
                                "aria-current": index === BreadCrumbsData[name].links.length - 1 && page !== SINGLE_SERVICE ? "page" : "step",
                                children: item.title
                            }, index);
                        }),
                        page === SINGLE_SERVICE && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: router.asPath,
                            "aria-current": "page",
                            children: router.query.serviceCenterSlug.toString().replace(/-/g, " ")
                        })
                    ]
                }),
                modelName && id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/models",
                            children: "לכל הדגמים"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: carLinkUrl(),
                            "aria-current": page !== CONFIGURATOR ? "page" : "step",
                            children: modelName
                        }),
                        page && page === CONFIGURATOR && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: router.asPath,
                            "aria-current": "page",
                            children: "התאמה אישית ורכישה"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var BreadCrumbs = (BreadCrumbsWrapper);


/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 74962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41810);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* display: flex; */\n  /* flex-wrap: wrap; */\n  /* gap: ",
        "px; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  ",
        " {\n    width: 50%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 44px;\n  border: solid 1px transparent;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  background-color: ",
        ";\n  font-size: 16px;\n  direction: ",
        ";\n  cursor: pointer;\n  position: relative;\n  ",
        "\n\n  @media print {\n    display: none;\n    justify-content: flex-start;\n    box-shadow: none;\n    background-image: none !important;\n\n    span {\n      justify-content: flex-start;\n    }\n  }\n\n  b {\n    font-size: 1.5em;\n  }\n\n  span {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    inset: 0;\n    line-height: 1;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  border: 0;\n  margin: -1px;\n  padding: 0;\n  border-radius: 50%;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n\n  &:focus-visible + label {\n    border: 2px dashed white;\n    outline: 3px dashed #0e3487;\n    outline-offset: 2px;\n  }\n\n  :checked + ",
        " {\n    border-color: ",
        ";\n    color: ",
        ';\n    background-image: url("/battery-button.svg");\n    @media print {\n      display: block;\n      border: none;\n    }\n  }\n\n  :focus + ',
        " {\n    border-color: ",
        ";\n    color: ",
        ';\n    background-image: url("/battery-button.svg");\n    @media print {\n      display: block;\n      border: none;\n    }\n  }\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SingleButtonSelection__StyledContainer",
    componentId: "sc-f3a656e3-0"
})(_templateObject(), function(props) {
    return props.$gap;
});
var StyledButtonWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    displayName: "SingleButtonSelection__StyledButtonWrap",
    componentId: "sc-f3a656e3-1"
})(_templateObject1(), function(props) {
    return props.$itemsPerRow === "auto" ? "auto" : "calc(100% / ".concat(props.$itemsPerRow, " - ").concat(props.$gap, "px * (").concat(props.$itemsPerRow, " - 1) / ").concat(props.$itemsPerRow, ") ");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    displayName: "SingleButtonSelection__StyledLabel",
    componentId: "sc-f3a656e3-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.$isBattery ? "ltr" : "rtl";
}, function(p) {
    return !p.$isBattery && "box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);";
}, function(p) {
    return p.$isBattery ? "\n    background-image:url('/battery-disabled.svg');\n    background-size:contain;\n    background-repeat:no-repeat;\n    border:none;\n    height: 0;\n    padding-bottom: calc( 100% * 59 / 232);\n    position: relative;\n\n  " : "background-image:none !important;";
});
var StyledRadio = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    displayName: "SingleButtonSelection__StyledRadio",
    componentId: "sc-f3a656e3-3"
})(_templateObject3(), StyledLabel, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, StyledLabel, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
});
var SingleButtonSelection = function(param) {
    var id = param.id, // title,
    items = param.items, onSelect = param.onSelect, isBattery = param.isBattery, customButton = param.customButton, // headlineComponent,
    selectedValue = param.selectedValue, className = param.className, _itemsPerRow = param.itemsPerRow, itemsPerRow = _itemsPerRow === void 0 ? 2 : _itemsPerRow, _gap = param.gap, gap = _gap === void 0 ? 0 : _gap;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(selectedValue || items[0].value), selectedButton = ref[0], setSelectedButton = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!items || !items.length) {
            return;
        }
        setSelectedButton(selectedValue || items[0].value);
    }, [
        items,
        selectedValue
    ]);
    var handleChange = function(value, index) {
        setSelectedButton(value);
        onSelect(value, index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
        role: "radiogroup",
        "aria-labelledby": id,
        $gap: gap,
        className: className,
        children: items.map(function(item, index) {
            var ref;
            var radioId = "radio_".concat(id, "_").concat(item.value);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledButtonWrap, {
                tabIndex: -1,
                role: "presentation",
                focusRipple: true,
                $itemsPerRow: itemsPerRow,
                $gap: gap,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledRadio, {
                        "aria-label": "כפתור רדיו",
                        type: "radio",
                        name: id,
                        value: item.value,
                        id: radioId,
                        checked: item.value === selectedButton,
                        // disabled={!color.details.inStock}
                        onChange: function() {
                            handleChange(item.value, index);
                            setSelectedButton(item.value);
                        }
                    }),
                    customButton ? customButton(radioId, item.value === selectedButton, item, index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLabel, {
                        $isBattery: isBattery,
                        htmlFor: radioId,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                            children: [
                                item.secondaryName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("b", {
                                    children: [
                                        item.secondaryName.toUpperCase(),
                                        "\xa0"
                                    ]
                                }),
                                (ref = item.name) === null || ref === void 0 ? void 0 : ref.toUpperCase()
                            ]
                        })
                    })
                ]
            }, "".concat(id, "-").concat(item.value, "-").concat(index));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SingleButtonSelection));


/***/ }),

/***/ 95055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var focus_formik_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73192);
/* harmony import */ var focus_formik_error__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(focus_formik_error__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82175);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledForm = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_3__.Form).withConfig({
    displayName: "FormikForm__StyledForm",
    componentId: "sc-1cd63cac-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
function FormikForm(param) {
    var validationSchema = param.validationSchema, initialValues = param.initialValues, render = param.render, onSubmit = param.onSubmit, innerRef = param.innerRef;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__.Formik, {
        innerRef: innerRef,
        initialValues: initialValues,
        validationSchema: validationSchema,
        validateOnBlur: true,
        validateOnChange: true,
        onSubmit: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(values, actions) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            actions.setSubmitting(true);
                            return [
                                4,
                                onSubmit(values, actions)
                            ];
                        case 1:
                            _state.sent();
                            actions.setSubmitting(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values, actions) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(formik) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledForm, {
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(focus_formik_error__WEBPACK_IMPORTED_MODULE_2__.ConnectedFocusError, {}),
                    render(formik)
                ]
            });
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FormikForm);


/***/ }),

/***/ 46363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ required; },
/* harmony export */   "Cr": function() { return /* binding */ schemaCommon; },
/* harmony export */   "Sz": function() { return /* binding */ regex; }
/* harmony export */ });
/* unused harmony exports max, invalid */
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);

var max = {
    fullname: [
        50,
        "ניתן להזין עד 50 תווים"
    ]
};
var required = {
    default: "שדה זה הינו שדה חובה",
    firstName: "יש להזין שם פרטי",
    lastName: "יש להזין שם משפחה",
    phoneNumber: "יש להזין מספר טלפון",
    licenseNumber: "יש להזין לוחית רישוי",
    licenceOrChassis: "נא הכנס מספר רישוי או שילדה",
    modelId: "בחר דגם",
    area: "בחר איזור",
    skuOrName: "נא הכנס טקסט חופשי או מספר פריט"
};
var regex = {
    numbersAndLetters: /^[a-zA-Zא-תא-ת0-9 ]+$/,
    numbers: /^[0-9]*$/,
    singleName: /^[a-zA-Zא-ת ״\-,.׳]+$/,
    fullName: /([a-zA-Zא-ת'"\\.-/,].+\s).+/,
    name: /^[A-Za-z\u00C0-\u017F\u0590-\u05fe ,.'-]+$/,
    phoneNumber: /^05\d([-]{0,1})\d{7}$/,
    licenseNumber: /^([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})$/,
    licenceOrChassis: /^(([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})|([A-Z]{2}[A-Z0-9]{12}))$/
};
var invalid = {
    numbers: "יש להזין ספרות בלבד",
    numbersShort: "ספרות בלבד",
    numbersAndLetters: "ספרות ואותיות",
    fullName: "שם מלא לא תקין",
    name: "יש להזין אותיות בעברית / אנגלית בלבד",
    email: "כתובת המייל אינה תקינה",
    phoneNumber: "מספר הטלפון אינו תקין",
    licenseNumber: "לוחית רישוי אינה תקינה, נא להזין מספר בעל 7-8 ספרות שמורכב מספרות בלבד",
    licenceOrChassis: "מספר רישוי או שילדה לא תקין"
};
var schemaCommon = {
    phoneNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.phoneNumber, "עד 10 ספרות, ללא מקף").length(10, "עד 10 ספרות, ללא מקף").required("עד 10 ספרות, ללא מקף").max(10, "עד 10 ספרות, ללא מקף"),
    firstName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.singleName, "רק אותיות בעברית או באנגלית בבקשה").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(50, "יש להזין עד 50 תווים בלבד").required(required.default),
    lastName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.singleName, "רק אותיות בעברית או באנגלית בבקשה").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(50, "יש להזין עד 50 תווים בלבד").required(required.default),
    fullName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.fullName, "שם מלא בבקשה :)").max(100, "יש להזין עד 100 תווים בלבד").required(required.default),
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("כתובת המייל לא תקינה").required(required.default),
    city: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
    street: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
    apartmentNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbersShort),
    floorNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbersShort),
    entranceNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbersAndLetters, invalid.numbersAndLetters),
    comments: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(200, "ניתן להזין עד 200 תווים"),
    termsOfUseCheckbox: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().required("").oneOf([
        true
    ], "יש לאשר את תנאי השימוש"),
    onlyNumbers: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbersShort),
    organization: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(100, "יש להזין עד 100 תווים בלבד"),
    organizationTitle: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(100, "יש להזין עד 100 תווים בלבד"),
    checkboxRequired: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().required("").oneOf([
        true
    ], "שדה חובה"),
    checkboxNotRequired: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().defined(),
    licenseNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("לוחית רישוי אינה תקינה, נא להזין מספר בעל 7-8 ספרות ברצף וללא מקף").matches(regex.licenseNumber, invalid.licenseNumber),
    chassis: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("מספר שילדה אינו תקין"),
    catalog: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(required.default)
};


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 7399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ initialFormStatesCarFleet; }
/* harmony export */ });
/* harmony import */ var common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46363);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74231);


var schemaCarFleet = yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry({
    subject: yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_().required("שדה חובה"),
    firstName: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.firstName */ .Cr.firstName,
    lastName: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.lastName */ .Cr.lastName,
    email: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.email */ .Cr.email,
    phoneNumber: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.phoneNumber */ .Cr.phoneNumber,
    organization: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.organization */ .Cr.organization,
    organizationTitle: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.organizationTitle */ .Cr.organizationTitle,
    approveMailingList: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.checkboxNotRequired */ .Cr.checkboxNotRequired,
    message: yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_().max(500, "יש להזין עד 500 תווים בלבד")
}).defined();
var initialFormStatesCarFleet = {
    subject: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
    organization: "",
    organizationTitle: "",
    approveMailingList: false
};
/* harmony default export */ __webpack_exports__["Z"] = (schemaCarFleet);


/***/ }),

/***/ 83225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ formsComp_FormSelect; },
  "L": function() { return /* binding */ toFormSelectOptions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js + 1 modules
var InputLabel = __webpack_require__(85161);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/formik-material-ui/dist/formik-material-ui.es6.js + 4 modules
var formik_material_ui_es6 = __webpack_require__(24065);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./common/bit/form/FormikSelect.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .MuiSelect-root {\n      &:focus-visible {\n        border: 2px dashed white;\n        outline: 3px dashed #0e3487;\n        outline-offset: 2px;\n      }\n    }\n\n    ",
        "\n    width: 100%;\n    .MuiFormHelperText-contained {\n      margin-right: 0;\n    }\n    .MuiFormHelperText-root {\n      font-size: 12px;\n    }\n    /* text alignment: */\n    .MuiSelect-outlined.MuiSelect-outlined {\n      text-align: initial;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Styled = {
    Field: (0,styled_components_browser_esm/* default */.ZP)(formik_esm.Field).withConfig({
        displayName: "FormikSelect__Field",
        componentId: "sc-fb0e1fb7-0"
    })(_templateObject(), function(p) {
        return (p === null || p === void 0 ? void 0 : p.$hiddenLabel) && "label { display: none; }";
    })
};
function FormikSelect(_param) {
    var name = _param.name, label = _param.label, _required = _param.required, required = _required === void 0 ? false : _required, selectValues = _param.selectValues, map = _param.map, placeholder = _param.placeholder, hiddenLabel = _param.hiddenLabel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "selectValues",
        "map",
        "placeholder",
        "hiddenLabel"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.Field, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        component: formik_material_ui_es6/* TextField */.nv,
        select: true,
        name: name,
        id: name,
        required: required,
        label: label,
        helperText: " ",
        $hiddenLabel: hiddenLabel,
        placeholder: placeholder
    }, props), {
        children: selectValues === null || selectValues === void 0 ? void 0 : selectValues.map(function(value, i) {
            var ref = map(value), name = ref.name, id = ref.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                value: id,
                children: name
            }, i);
        })
    }));
}
/* harmony default export */ var form_FormikSelect = (FormikSelect);

;// CONCATENATED MODULE: ./reusable/formsComp/FormSelect.tsx



function FormSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    FormSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: none !important;\n    font-size: 16px;\n    color: ",
        ";\n    font-weight: 400;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: start;\n    font-size: 12px;\n    margin-top: -23px;\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var FormSelect_Styled = {
    FormControl: (0,styled_components_browser_esm/* default */.ZP)(FormControl/* default */.Z).withConfig({
        displayName: "FormSelect__FormControl",
        componentId: "sc-8af10bf7-0"
    })(FormSelect_templateObject()),
    FieldWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        displayName: "FormSelect__FieldWrapper",
        componentId: "sc-8af10bf7-1"
    })(_templateObject1(), function(p) {
        if ((p === null || p === void 0 ? void 0 : p.$marginTop) === 0) return "0px";
        if (p === null || p === void 0 ? void 0 : p.$marginTop) return p.$marginTop + "px";
        return "22px";
    }),
    InputLabel: (0,styled_components_browser_esm/* default */.ZP)(InputLabel/* default */.Z).withConfig({
        displayName: "FormSelect__InputLabel",
        componentId: "sc-8af10bf7-2"
    })(_templateObject2(), function(p) {
        return p.theme.colors.darkGrey;
    }),
    BottomText: (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
        variant: "body1"
    }).withConfig({
        displayName: "FormSelect__BottomText",
        componentId: "sc-8af10bf7-3"
    })(_templateObject3(), function(p) {
        return p.theme.colors.marbleGrey;
    })
};
var toFormSelectOptions = function(list, idProp, nameProp) {
    return list.map(function(item) {
        return {
            id: item[idProp],
            name: item[nameProp]
        };
    });
};
function FormSelect(_param) {
    var name = _param.name, label = _param.label, _required = _param.required, required = _required === void 0 ? false : _required, values = _param.values, // bottomText,
    map = _param.map, placeholder = _param.placeholder, hiddenLabel = _param.hiddenLabel, marginTop = _param.marginTop, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "values",
        "map",
        "placeholder",
        "hiddenLabel",
        "marginTop"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect_Styled.FieldWrapper, {
            $marginTop: marginTop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_FormikSelect, (0,_object_spread/* default */.Z)({
                label: label,
                name: name,
                required: required,
                selectValues: values,
                hiddenLabel: hiddenLabel,
                map: map,
                placeholder: placeholder
            }, props))
        })
    });
}
/* harmony default export */ var formsComp_FormSelect = (FormSelect);


/***/ }),

/***/ 88735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ popups_VideoPopUp; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./common/CloseButton.tsx + 1 modules
var CloseButton = __webpack_require__(92217);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./common/YouTubePlayer.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 100%;\n    margin-top: ",
        ";\n    position: relative;\n    ",
        "\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0 auto;\n    max-width: 100%;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Styled = {
    PlayerWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        displayName: "YouTubePlayer__PlayerWrapper",
        componentId: "sc-3ebeafb8-0"
    })(_templateObject(), function(p) {
        return p.$noMargin ? "0" : "52px";
    }, function(p) {
        return !p.$setAbsolute ? "" : "position:absolute;\n    top:0;\n    left:0;\n    width:100%;\n    height:100%;";
    }),
    ReactPlayer: (0,styled_components_browser_esm/* default */.ZP)(lib/* default */.Z).attrs({
        muted: true,
        controls: true
    }).withConfig({
        displayName: "YouTubePlayer__ReactPlayer",
        componentId: "sc-3ebeafb8-1"
    })(_templateObject1())
};
function YouTubePlayer(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.PlayerWrapper, {
        $noMargin: props.noMargin,
        $setAbsolute: props.setAbsolute,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.ReactPlayer, {
            url: props.url,
            width: props.width,
            height: props.height,
            playing: props.playing
        })
    });
}

;// CONCATENATED MODULE: ./reusable/popups/VideoPopUp.tsx

function VideoPopUp_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :focus {\n    color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    VideoPopUp_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoPopUp_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  padding: 50px 10px 10px;\n"
    ]);
    VideoPopUp_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var StyledCloseButton = (0,styled_components_browser_esm/* default */.ZP)(CloseButton/* default */.Z).withConfig({
    displayName: "VideoPopUp__StyledCloseButton",
    componentId: "sc-f19a0da3-0"
})(VideoPopUp_templateObject(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.white;
});
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VideoPopUp__StyledContainer",
    componentId: "sc-f19a0da3-1"
})(VideoPopUp_templateObject1());
var StyledVideo = (0,styled_components_browser_esm/* default */.ZP)(YouTubePlayer).withConfig({
    displayName: "VideoPopUp__StyledVideo",
    componentId: "sc-f19a0da3-2"
})(_templateObject2());
var VideoPopUp = function(param) {
    var url = param.url, open = param.open, onClose = param.onClose, label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: open,
        onClose: onClose,
        maxWidth: "md",
        PaperProps: {
            style: {
                backgroundColor: "transparent",
                maxWidth: "fit-content",
                width: "100%",
                boxShadow: "none"
            }
        },
        "aria-label": label,
        disableAutoFocus: false,
        role: "dialog",
        "aria-modal": "true",
        tabIndex: -1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
            role: "dialog",
            "aria-modal": true,
            tabIndex: -1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCloseButton, {
                    color: "secondary",
                    onClick: onClose,
                    "aria-label": "close window"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledVideo, {
                    url: url,
                    noMargin: true
                })
            ]
        })
    });
};
/* harmony default export */ var popups_VideoPopUp = (VideoPopUp);


/***/ }),

/***/ 63358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  height: 150px;\n  ",
        " {\n    height: 270px;\n    ",
        ";\n  }\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ImageContainer__StyledImageContainer",
    componentId: "sc-4c5af28c-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$collapseOpen && "margin-top: 63px";
});
var ImageContainer = function(param) {
    var src = param.src;
    var collapseOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)(function(state) {
        return state.collapseLayout;
    }).collapseOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        $collapseOpen: collapseOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: src,
            layout: "fill",
            priority: true,
            alt: "page-cover-img",
            role: "presentation",
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageContainer);


/***/ }),

/***/ 45732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var common_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15738);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);
/* harmony import */ var _ImageContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63358);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  padding-top: ",
        "px;\n  flex-direction: column;\n  background-color: ",
        ";\n  ",
        " {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: 60px;\n  flex-direction: column;\n  width: 100%;\n  padding-right: 20px;\n  padding-left: 20px;\n  ",
        " {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 80px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 40px 20px;\n  padding-bottom: ",
        ";\n  ",
        " {\n    padding: 40px 20px 20px;\n    max-width: 800px;\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  margin-top: 10px;\n  ",
        " {\n    margin-top: 20px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var StyledPageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InnerPageWrapper__StyledPageWrapper",
    componentId: "sc-df466e4e-0"
})(_templateObject(), theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_HEIGHT_M */ .Gi, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_HEIGHT_D */ .gw);
var StyledPageWrap = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InnerPageWrapper__StyledPageWrap",
    componentId: "sc-df466e4e-1"
})(_templateObject1());
var StyledContentWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledContentWrap",
    componentId: "sc-df466e4e-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledHeader",
    componentId: "sc-df466e4e-3"
})(_templateObject3(), function(p) {
    return "".concat(p.$paddingBottom && p.$paddingBottom, "px");
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return "".concat(p.$paddingBottom && p.$paddingBottom, "px !important");
});
var StyledHeadline = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
    variant: "h2",
    component: "h1"
}).withConfig({
    displayName: "InnerPageWrapper__StyledHeadline",
    componentId: "sc-df466e4e-4"
})(_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledSubtitle",
    componentId: "sc-df466e4e-5"
})(_templateObject5(), function(p) {
    return p.theme.breakpoints.up("md");
});
var InnerPageWrapper = function(param) {
    var imgUrl = param.imgUrl, title = param.title, subtitle = param.subtitle, children = param.children, breadCrumbName = param.breadCrumbName, page = param.page, paddingBottom = param.paddingBottom, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPageWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPageWrap, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImageContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    src: imgUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    name: breadCrumbName,
                    page: page
                }),
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeader, {
                    $paddingBottom: paddingBottom,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeadline, {
                            children: [
                                " ",
                                title,
                                " "
                            ]
                        }),
                        subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubtitle, {
                            dangerouslySetInnerHTML: {
                                __html: subtitle
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContentWrap, {
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InnerPageWrapper);


/***/ }),

/***/ 43042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ video_tutorials; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/bit/SingleButtonSelection.tsx
var SingleButtonSelection = __webpack_require__(74962);
// EXTERNAL MODULE: ./common/bit/form/FormikForm.tsx
var FormikForm = __webpack_require__(95055);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./reusable/ButtonBaseBlank.tsx
var ButtonBaseBlank = __webpack_require__(59041);
// EXTERNAL MODULE: ./reusable/formsComp/FormSelect.tsx + 1 modules
var FormSelect = __webpack_require__(83225);
// EXTERNAL MODULE: ./reusable/popups/VideoPopUp.tsx + 1 modules
var VideoPopUp = __webpack_require__(88735);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(22038);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./reusable/wrappers/InnerPageWrapper.tsx
var InnerPageWrapper = __webpack_require__(45732);
// EXTERNAL MODULE: ./components/pages/carFleet/SchemaCarFleet.ts
var SchemaCarFleet = __webpack_require__(7399);
// EXTERNAL MODULE: ./common/bit/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(49138);
;// CONCATENATED MODULE: ./components/pages/videoTutorial/VideoCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 316px;\n  height: 316px;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0.2) 100%);\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  padding: 25px;\n  flex-direction: column;\n  justify-content: space-between;\n  display: flex;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var StyledCardWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VideoCard__StyledCardWrap",
    componentId: "sc-6c1efea8-0"
})(_templateObject());
var StyledImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VideoCard__StyledImageContainer",
    componentId: "sc-6c1efea8-1"
})(_templateObject1());
var StyledGradientOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VideoCard__StyledGradientOverlay",
    componentId: "sc-6c1efea8-2"
})(_templateObject2());
var StyledCardContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VideoCard__StyledCardContent",
    componentId: "sc-6c1efea8-3"
})(_templateObject3());
var VideoCard = function(param) {
    var data = param.data, selectedModel = param.selectedModel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardWrap, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledImageContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                    image: {
                        imageUrl: (data === null || data === void 0 ? void 0 : data.previewPicture) || "/img/placeholder.jpeg",
                        alt: (data === null || data === void 0 ? void 0 : data.name) || "video-img"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGradientOverlay, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledRow */.N0, {
                            $fullWidth: true,
                            $gap: "10px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledDividerV */.yE, {
                                    $color: colors/* default.mazdaRed */.Z.mazdaRed,
                                    $width: 5,
                                    $radius: 3
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledCol */.N6, {
                                    $notCenter: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                                            $color: colors/* default.white */.Z.white,
                                            variant: "h2",
                                            children: selectedModel
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                                            $color: colors/* default.white */.Z.white,
                                            variant: "caption",
                                            children: data === null || data === void 0 ? void 0 : data.name
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledCol */.N6, {
                            $fullWidth: true,
                            $notCenter: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                                    src: "/icons/big-play-icon.svg",
                                    alt: "play-button",
                                    w: 50,
                                    h: 50
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                                    $color: colors/* default.white */.Z.white,
                                    variant: "caption",
                                    $mt: "5px",
                                    children: data === null || data === void 0 ? void 0 : data.description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var videoTutorial_VideoCard = (VideoCard);

;// CONCATENATED MODULE: ./components/pages/videoTutorial/VideoTutorialPage.tsx




function VideoTutorialPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n"
    ]);
    VideoTutorialPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoTutorialPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: 34px;\n  margin: 40px 0px;\n  /* sdfkjhsdfjkdhsf */\n  /* hide scrollbar: */\n  overflow-x: auto;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  &::-webkit-scrollbar {\n    /* WebKit */\n    display: none;\n  }\n  ",
        " {\n    justify-content: center;\n    gap: 74px;\n    padding: 5px;\n  }\n"
    ]);
    VideoTutorialPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VideoTutorialPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  :focus {\n    outline: none;\n  }\n  div {\n    max-width: 50px;\n    /* ssdfdsfsdfsfddsf */\n  }\n"
    ]);
    VideoTutorialPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function VideoTutorialPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 320px;\n  margin: 0px auto;\n"
    ]);
    VideoTutorialPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 40px auto 0px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
















var StyledTabsWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VideoTutorialPage__StyledTabsWrap",
    componentId: "sc-f1cc2a00-0"
})(VideoTutorialPage_templateObject());
var StyledSingleButtonSelection = (0,styled_components_browser_esm/* default */.ZP)(SingleButtonSelection/* default */.Z).withConfig({
    displayName: "VideoTutorialPage__StyledSingleButtonSelection",
    componentId: "sc-f1cc2a00-1"
})(VideoTutorialPage_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledButton = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "VideoTutorialPage__StyledButton",
    componentId: "sc-f1cc2a00-2"
})(VideoTutorialPage_templateObject2());
var StyledFormSelectWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VideoTutorialPage__StyledFormSelectWrapper",
    componentId: "sc-f1cc2a00-3"
})(VideoTutorialPage_templateObject3());
var StyledButtonText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "caption"
}).withConfig({
    displayName: "VideoTutorialPage__StyledButtonText",
    componentId: "sc-f1cc2a00-4"
})(_templateObject4(), function(p) {
    return p.$activeButton ? p.theme.colors.black : p.theme.colors.disable;
}, function(p) {
    return p.$activeButton ? "bold" : "normal";
});
var StyledButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VideoTutorialPage__StyledButtonWrap",
    componentId: "sc-f1cc2a00-5"
})(_templateObject5());
var ADD_MORE_CARDS = 6;
var VideoTutorialPage = function(param) {
    var data = param.data;
    var ref = (0,react.useState)(ADD_MORE_CARDS), next = ref[0], setNext = ref[1];
    var ref1 = (0,react.useState)(null), selectedVideoUrl = ref1[0], setSelectedVideoUrl = ref1[1];
    var ref2 = (0,react.useState)(false), selectedVideoPopUp = ref2[0], setSelectedVideoPopUp = ref2[1];
    var ref3 = (0,react.useState)(null), selectedModel = ref3[0], setSelectedModel = ref3[1];
    var ref4 = (0,react.useState)(data.categories[0].id), selectedCategoryId = ref4[0], setSelectedCategoryId = ref4[1];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref5 = (0,react.useState)([]), videosToShow = ref5[0], setVideosToShow = ref5[1];
    var ref6 = (0,react.useState)([]), allVideos = ref6[0], setAllVideos = ref6[1];
    var videoRef = (0,react.useRef)(null);
    var modelsList = data.carVideos.map(function(item) {
        return item.carName;
    }).filter(function(value, i, array) {
        return array.indexOf(value) === i;
    }).sort(function(a, b) {
        return a.localeCompare(b);
    });
    (0,react.useEffect)(function() {
        if (!selectedModel && modelsList) {
            setSelectedModel(modelsList[0]);
        }
    }, [
        modelsList
    ]);
    (0,react.useEffect)(function() {
        // Filter videos by category
        var filteredVideos = data.carVideos.filter(function(item) {
            if (selectedCategoryId === data.categories[0].id) {
                return true;
            }
            return item.categoryId === selectedCategoryId;
        })// Filter videos by car model
        .filter(function(item) {
            if (selectedModel === null) {
                return true;
            }
            return item.carName === selectedModel;
        });
        setAllVideos(filteredVideos);
        setVideosToShow(filteredVideos.slice(0, next));
    }, [
        data.carVideos,
        data.categories,
        next,
        selectedCategoryId,
        selectedModel
    ]);
    var handleMoreClick = (0,react.useCallback)(function() {
        // get the next X videos
        var nextVideos = allVideos.slice(next, next + ADD_MORE_CARDS);
        // update the next index
        setNext(function(prev) {
            return prev + ADD_MORE_CARDS;
        });
        // update the videos to show
        setVideosToShow((0,_to_consumable_array/* default */.Z)(videosToShow).concat((0,_to_consumable_array/* default */.Z)(nextVideos)));
    }, [
        allVideos,
        next,
        videosToShow
    ]);
    (0,react.useEffect)(function() {
        videoRef && videoRef.current && videoRef.current.focusVisible();
    }, [
        videoRef,
        videosToShow
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerPageWrapper/* default */.Z, {
        title: "המאזדה שלך, נעים להכיר",
        subtitle: "המושב שמתכוונן בדיוק בשבילך, מערכות הבטיחות האקטיביות שיגנו עליך ומערך התקשורת החכם - ככל שמכירים אותה יותר, ככה היא מרגשת יותר. כדי להפיק את המקסימום מהמאזדה שלך, הכנו סרטונים שמציגים את כל היכולות והפרטים שכדאי להכיר",
        imgUrl: isDesktop ? "/img/cover/tutorialvideos.jpg" : "/img/cover/tutorialvideosmobile.jpg",
        breadCrumbName: "VideoTutorials",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
                validationSchema: SchemaCarFleet/* default */.Z,
                initialValues: SchemaCarFleet/* initialFormStatesCarFleet */.I,
                onSubmit: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                }),
                render: function() {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(StyledFormSelectWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* default */.Z, {
                            id: "cityAutocomplete",
                            name: "select",
                            color: "primary",
                            label: "בחירת דגם",
                            values: modelsList,
                            map: function(item) {
                                return {
                                    id: item,
                                    name: item
                                };
                            },
                            onChange: function(e) {
                                var ref;
                                setSelectedModel(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                setNext(ADD_MORE_CARDS);
                            },
                            focused: true,
                            value: selectedModel
                        })
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "srOnly",
                component: "span",
                id: "era-selection",
                children: "סינון סרטונים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTabsWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSingleButtonSelection, {
                    id: "era-selection",
                    items: data.categories.map(function(item) {
                        return {
                            value: item.id,
                            name: item.name,
                            radioItemMore: {
                                checkIcon: item.checkIcon,
                                unCheckIcon: item.unCheckIcon
                            }
                        };
                    }),
                    itemsPerRow: "auto",
                    selectedValue: selectedCategoryId,
                    onSelect: function(code) {
                        setSelectedCategoryId(Number(code));
                        setNext(ADD_MORE_CARDS);
                    },
                    customButton: function(radioId, isSelected, item) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(StyledButton, {
                            htmlFor: radioId,
                            $activeButton: isSelected,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledCol */.N6, {
                                $gap: "4px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: item.name,
                                        src: isSelected ? item === null || item === void 0 ? void 0 : item.radioItemMore.checkIcon : item === null || item === void 0 ? void 0 : item.radioItemMore.unCheckIcon,
                                        width: 22,
                                        height: 22,
                                        objectFit: "contain"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonText, {
                                        $activeButton: isSelected,
                                        children: item.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledDividerH */.aV, {
                                        $color: isSelected ? colors/* default.black */.Z.black : "transparent",
                                        $width: 4,
                                        $radius: 3
                                    })
                                ]
                            })
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledRow */.N0, {
                $gap: "40px",
                $fullWidth: true,
                $wrap: true,
                $justify: "center",
                children: videosToShow === null || videosToShow === void 0 ? void 0 : videosToShow.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBaseBlank/* default */.Z, {
                        onClick: function() {
                            setSelectedVideoUrl(item.videoUrl);
                            setSelectedVideoPopUp(true);
                        },
                        action: index === next - 6 ? videoRef : null,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(videoTutorial_VideoCard, {
                            data: item,
                            selectedModel: selectedModel
                        })
                    }, "video-".concat(item.id));
                })
            }),
            next < (allVideos === null || allVideos === void 0 ? void 0 : allVideos.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "outlined",
                    onClick: function() {
                        return handleMoreClick();
                    },
                    children: "עוד סרטונים"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPopUp/* default */.Z, {
                url: selectedVideoUrl,
                open: selectedVideoPopUp,
                onClose: function() {
                    setSelectedVideoPopUp(false);
                    setSelectedVideoUrl(null);
                },
                label: "video-lable"
            })
        ]
    });
};
/* harmony default export */ var videoTutorial_VideoTutorialPage = (VideoTutorialPage);

;// CONCATENATED MODULE: ./src/pages/video-tutorials.tsx



var VideoTutorials = function(param) {
    var pageData = param.pageData, seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(videoTutorial_VideoTutorialPage, {
                data: pageData
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var video_tutorials = (VideoTutorials);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4245,2669,2004,6004,9774,2888,179], function() { return __webpack_exec__(82044); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);